import type { Shape } from '../../model/types';

export const DEFAULT_SHAPE_Z_INDEX = 0;

export const getShapeZIndex = (shape: Shape): number =>
  typeof shape.zIndex === 'number' && Number.isFinite(shape.zIndex) ? shape.zIndex : DEFAULT_SHAPE_Z_INDEX;

export const normalizeShapeZIndexes = (shapes: Shape[]): Shape[] =>
  shapes.map((shape, index) => ({
    ...shape,
    zIndex: getShapeZIndex(shape) === DEFAULT_SHAPE_Z_INDEX && shape.zIndex === undefined ? index : getShapeZIndex(shape),
  }));

export const sortShapesByZIndex = (shapes: Shape[]): Shape[] =>
  shapes
    .map((shape, index) => ({ shape, index }))
    .sort((a, b) => getShapeZIndex(a.shape) - getShapeZIndex(b.shape) || a.index - b.index)
    .map(({ shape }) => shape);

export const getNextShapeZIndex = (shapes: Shape[]): number => {
  if (!shapes.length) return DEFAULT_SHAPE_Z_INDEX;
  return Math.max(...shapes.map(getShapeZIndex)) + 1;
};

export const getPreviousShapeZIndex = (shapes: Shape[]): number => {
  if (!shapes.length) return DEFAULT_SHAPE_Z_INDEX;
  return Math.min(...shapes.map(getShapeZIndex)) - 1;
};
